/** Placement metadata must never decide the legal Consent runtime boundary. */
export const isConsentQuestion = (question) => (
  String(question?.question_type || question?.kind || "").toLowerCase()
    === "consent"
);

const classification = (question) => String(
  question?.consent_classification
  || question?.consentClassification
  || "",
).trim().toLowerCase();

/**
 * A true inline Consent is an authored Program question, not a Stage-3 node.
 * New releases carry an explicit classifier marker.  The metadata fallback is
 * retained only for immutable releases published before that marker existed.
 */
export const isInlineProgramConsentQuestion = (question) => (
  isConsentQuestion(question)
  && (
    classification(question) === "inline_conditional_consent"
    || (
      !classification(question)
      && Boolean(String(question?.program_id || "").trim())
      && (
        question?.scope === "program"
        || !String(question?.release_node_id || "").trim()
      )
      && question?.consent_boundary !== "stage_3"
      && question?.runtime_scope !== "consent"
    )
  )
);

/**
 * Canonical manifest Consents live at Stage 3. The negative inline check also
 * keeps immutable releases from before runtime_scope was introduced working.
 */
export const isCanonicalConsentQuestion = (question) => (
  isConsentQuestion(question)
  && classification(question) !== "inline_conditional_consent"
  && !isInlineProgramConsentQuestion(question)
);
